import { createContext, PropsWithChildren, useContext, useMemo } from 'react';

import { useQueryGetAccountBalances } from '~hooks/useQueryGetAccountBalances';
import { AccountBalancesResponse } from '~types/account-balances.type';

type AccountBalancesContextType = {
  accountBalancesData: AccountBalancesResponse | undefined;
  isLoadingAccountBalances: boolean;
};

const AccountBalancesContext = createContext<AccountBalancesContextType>({
  accountBalancesData: undefined,
  isLoadingAccountBalances: false,
});

export const AccountBalancesProvider: React.FC<PropsWithChildren> = ({
  children,
}) => {
  const { data, isFetching } = useQueryGetAccountBalances();

  const providerValues = useMemo(
    () => ({
      accountBalancesData: data,
      isLoadingAccountBalances: isFetching,
    }),
    [data, isFetching],
  );

  return (
    <AccountBalancesContext.Provider value={providerValues}>
      {children}
    </AccountBalancesContext.Provider>
  );
};

export const useAccountBalancesContext = () =>
  useContext(AccountBalancesContext);
